module.exports = __webpack_public_path__ + "media/images/tondo_nervato_laterale-ffefb9002fa60609fce0c70a412c576d.svg";